<template>
  <!-- 图片上传 -->
  <div class="upload">
    <div class="upload-title">
      {{ title }}
    </div>
    <div class="upload-image">
      <div
        class="image-box" v-for="(item, index) in list"
        :key="index">
        <img
          v-show="!isDisabled"
          @click="deleteImg(index)"
          class="clear-icon"
          :src="clearIcon" alt="">
        <img
          class="normal-image"
          :src="item.url"
          @click="lookImg(index)"
          @error="deleteImg(index, 'error')"
          alt="" />
      </div>
      <div class="image-box" @click="uploadImg" v-show="!isDisabled && (list.length < maxLength)">
        <img
          class="add-icon"
          :src="uploadIcon"
          alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import {
  Upload_add,
  Reject_Rd_Gray
} from '@/images/index'
import {
  showToast,
  takePictureOid,
  showPhotoBrowser
} from '@/utils/nativeBridge'
import { imgDownload } from '@/service/claimApplication/index'
export default {
  name: 'ImageUpload',
  props: {
    // 标题
    title: {
      type: String,
      default: ''
    },
    //  最大可上传图片张数
    maxLength: {
      type: Number,
      default: 5
    },
    maxFileSize: {
      type: Number,
      default: 500
    },
    // 上传到哪个接口
    categoryid: {
      type: String,
      default: 'policy'
    },
    // 图片数组，如下
    // [{
    //     oid: '4215958b-64d9-4028-8775-91a9a7a81e81',
    //     url: 'https://smmartdevblob01.blob.core.windows.net/policy/4215958b-64d9-4028-8775-91a9a7a81e84?se=2021-04-29T17%3A00%3A06Z&sp=r&sv=2018-03-28&sr=c&sig=o6yR/1ctCuZ8qefTt0ZvppMHKu8gOrreYO5YxoWN6KY%3D'
    //   }]
    list: {
      type: Array,
      default: () => []
    },
    // 是否禁止上传，即预览模式
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      uploadIcon: Upload_add,
      clearIcon: Reject_Rd_Gray
    }
  },
  methods: {
    async uploadImg () {
      const data = await takePictureOid({ categoryid: this.categoryid, fileSize: this.maxFileSize })
      // console.log(data)
      // eslint-disable-next-line
      if (parseInt(data.isCanceled) === 0 && data.result) {
        if (data.result.code && parseInt(data.result.code) !== 0) {
          showToast(this.$t('uploadFaild'), 1)
          return
        }
        if (data.result.data && data.result.data.oid) {
          const urlData = await imgDownload(this.categoryid, data.result.data.oid)
          const result = [...this.list, { oid: data.result.data.oid, url: urlData.url }]
          this.$emit('onChange', result)
        }
      }
    },
    lookImg (index) {
      const imgs = this.list.map(item => item.url)
      showPhotoBrowser({ urls: imgs, index })
    },
    deleteImg (index, type) {
      if (type === 'error') {
        showToast(this.$t('uploadFaild'), 1)
      }
      const result = this.list.filter((item, ind) => ind !== index)
      this.$emit('onChange', result)
    }
  }
}
</script>

<style scoped lang="scss">
.upload {
  // margin-bottom: 30px;
  .upload-title {
    margin-bottom: 15px;
    color: #666;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    letter-spacing: 0;
  }
  .upload-image {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    .image-box {
      &:nth-child(3n-1) {
        margin-right: 12px;
        margin-left: 12px;
      }

      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 105px;
      height: 105px;
      margin-bottom: 14px;
      border: 0.5px solid #ccc;
      border-radius: 4px;
      background: #f7f8fa;
      .normal-image {
        width: 105px;
        height: 105px;
      }
      .add-icon {
        width: 20px;
        height: 20px;
      }
      .clear-icon {
        position: absolute;
        top: -10px;
        right: -10px;
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
